export function toMonetaryString(value) {
    if (typeof value === 'number') {
        return value.toLocaleString('en-US');
    }
    else {
        return value;
    }
}